var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar-component",class:[
        ("size-" + _vm.size) ]},[_c('ym-img',{staticClass:"avatar-img",attrs:{"src":_vm.avatar,"radius":"50%","alt":_vm.name,"lazy":_vm.lazy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }